<template>
  <v-container fill-height class="mt-15">
    <v-row justify="center" class="mt-15">
      <v-col align="center">
        <span class="text-h1">404</span>
        <br />
        <blockquote>There's nothing here.</blockquote>
        <v-btn text>
          <router-link :to="redirectTo">Take me home</router-link>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState("auth", ["user"]),
    redirectTo() {
      return this.user ? '/dashboard' : '/'
    }
  },
}
</script>

<style>
</style>